import {GetWithdrawalReason_getCuroCodes} from '../../../schema-types/GetWithdrawalReason';
import {SelectGroupOption, SelectOption} from '../../../components/AutoForm/AutoFieldNew';
import {recommendFieldsType} from '../CreateRecommend/recommendFields';
import {Pot} from '../../../schema-types/Pot';

// Distribution income {Not for Bond}
const DISTRIBUTION_INCOME = 'Distribution - Income';
// Distribution capital {Always}
const DISTRIBUTION_CAPITAL = 'Distribution - Capital';

// Full surrender {Only for Close Plan}
export const FULL_SURRENDER = 'Full Surrender';
export const PARTIAL_SURRENDER = 'Partial Surrender';
// Regular income {Only for not single freq}
const REGULAR_INCOME = 'Regular income';
const ADHOC_INCOME = 'Ad-hoc income';
// Tax free cash {Only Pension or GIA Gross}
const TAX_FREE_CASH = 'Tax free cash';
// Tax harvesting {Not for Pension or GIA Gross}
const TAX_HARVESTING = 'Tax harvesting';
const PAYMENT_OF_FEES = 'Payment of fees';

export type getWithdrawalReasonListValues = Pick<
  recommendFieldsType,
  'mainPlanType' | 'planAction'
>;

// number is used here just to shut up typescript
const ordering: (string | number)[] = [
  'Regular income',
  'Ad-hoc income',
  'Tax free cash',
  'Payment of fees',
  'Distribution - Income',
  'Distribution - Capital',
  'Partial Surrender',
  'Full Surrender',
  'Transfer',
  'Transfer in specie',
  'Tax harvesting',
  'Withdraw PCLS',
];

export const getWithdrawalReasonList = (
  withdrawalReasonList: Pick<GetWithdrawalReason_getCuroCodes, 'value'>[] | null,
  isSingleFrequency: boolean,
  isFull: boolean,
  values: getWithdrawalReasonListValues,
  sourcePot: Pot
): SelectGroupOption[] => {
  const {planAction = '', mainPlanType = ''} = values;
  const defaultOptions: SelectGroupOption = {groupLabel: 'Default', options: []};
  const otherOptions: SelectGroupOption = {groupLabel: 'Other', options: []};
  if (isFull) {
    defaultOptions.options = withdrawalReasonList
      ? withdrawalReasonList
          .filter((x) => x?.value === FULL_SURRENDER)
          .map<SelectOption>((x) => ({label: x.value!, value: x.value!}))
      : [];

    return [defaultOptions];
  }

  if (!isSingleFrequency) {
    defaultOptions.options = [
      ...((withdrawalReasonList || [])
        ?.filter((x) => [REGULAR_INCOME].includes(x?.value || ''))
        .map<SelectOption>((x) => ({label: x.value!, value: x.value!})) || []),
    ];
  }
  if (isSingleFrequency) {
    const adHoc = withdrawalReasonList?.find((x) => x.value === ADHOC_INCOME);
    if (adHoc) {
      defaultOptions.options.push({
        label: adHoc.value!,
        value: adHoc.value!,
      });
    }
  }
  const paymentOfFees = withdrawalReasonList?.find((x) => x.value === PAYMENT_OF_FEES);
  if (paymentOfFees) {
    otherOptions.options.push({
      label: paymentOfFees.value!,
      value: paymentOfFees.value!,
    });
  }

  const distCapital = withdrawalReasonList?.find(
    (x) => x?.value === DISTRIBUTION_CAPITAL
  );
  if (distCapital) {
    otherOptions.options.push({
      label: distCapital.value!,
      value: distCapital.value!,
    });
  }

  // if (mainPlanType !== POTS_BOND) {
  const distIncome = withdrawalReasonList?.find((x) => x?.value === DISTRIBUTION_INCOME);
  if (distIncome) {
    otherOptions.options.push({
      label: distIncome.value!,
      value: distIncome.value!,
    });
  }

  const partial = withdrawalReasonList?.find((x) => x?.value === PARTIAL_SURRENDER);
  if (partial) {
    otherOptions.options.push({
      label: partial.value!,
      value: partial.value!,
    });
  }

  const taxFreeCash = withdrawalReasonList?.find((x) => x?.value === TAX_FREE_CASH);
  // ON-1187 - Can only select TFC/UFPLS/Max TFC when frequency is single.
  if (taxFreeCash) {
    if (values.mainPlanType === 'pension' || sourcePot.parent?.id) {
      defaultOptions.options.push({
        label: taxFreeCash.value!,
        value: taxFreeCash.value!,
      });
    }
  }
  if (values.mainPlanType === 'pension' || sourcePot.parent?.id) {
    defaultOptions.options.push({
      label: 'UFPLS',
      value: 'UFPLS',
    });
  }

  // add custom reasons
  if (isSingleFrequency) {
    if (values.mainPlanType === 'pension' || sourcePot.parent?.id) {
      otherOptions.options.push({
        label: 'Max Tax Free Cash',
        value: 'Max Tax Free Cash',
      });
    }
  }

  // return reasonList;
  otherOptions.options = [...otherOptions.options].sort((a, b) => {
    const aIndex = ordering.indexOf(a.value);
    if (aIndex === -1) {
      return 1;
    }
    const bIndex = ordering.indexOf(b.value);
    if (bIndex === -1) {
      return -1;
    }
    return aIndex - bIndex;
  });
  defaultOptions.options = [...defaultOptions.options].sort((a, b) => {
    const aIndex = ordering.indexOf(a.value);
    if (aIndex === -1) {
      return 1;
    }
    const bIndex = ordering.indexOf(b.value);
    if (bIndex === -1) {
      return -1;
    }
    return aIndex - bIndex;
  });
  return [defaultOptions, otherOptions];
};
